import React, { FC, PropsWithChildren } from 'react';
import styles from './StepLayout.scss';
import { Text } from '@wix/design-system';
import { StepLayoutActions, StepLayoutActionsProps } from 'components/StepLayout/StepLayoutActions';
import { StepHeader } from 'components/StepHeader/StepHeader';

type Props = {
  title?: string;
  description?: string;
  hideActions?: boolean;
  disclaimer?: string;
  hideHeader?: boolean;
} & StepLayoutActionsProps;

export const StepLayout: FC<PropsWithChildren<Props>> = ({
  children,
  title,
  description,
  hideActions,
  disclaimer,
  hideHeader,
  ...stepLayoutActionsProps
}) => {
  return (
    <div className={styles.stepLayout}>
      {!hideHeader && (
        <div className={styles.stepLayoutHeader}>
          <StepHeader />
        </div>
      )}
      <div className={styles.stepLayoutContent}>
        <div className={styles.stepLayoutContentHeader}>
          {title && <p className={styles.stepLayoutTitle}>{title}</p>}
          {description && <p className={styles.stepLayoutDescription}>{description}</p>}
        </div>
        <div className={styles.stepLayoutBody}>{children}</div>
      </div>
      <div className={styles.stepLayoutFooter}>
        {disclaimer && (
          <div className={styles.stepLayoutDisclaimer}>
            <Text secondary light size="tiny">
              {disclaimer}
            </Text>
          </div>
        )}
        {!hideActions && <StepLayoutActions {...stepLayoutActionsProps} />}
      </div>
    </div>
  );
};
